export const inputsData = [
  {
    id: "1",
    name: "firstName",
    type: "text",
    placeholder: "Enter your name",
    onChange: "handleChange",
    height: "100px",
  },
  {
    id: "2",
    name: "email",
    type: "email",
    placeholder: "Your Email",
    onChange: "handleChange",
    minLength: 5,
    pattern: ".+@globex.com",
    height: "100px",
  },
  {
    id: "3",
    name: "message",
    type: "text-area",
    placeholder: "Your message",
    onChange: "handleChange",
    height: "200px",
  },
];
